// extracted by mini-css-extract-plugin
module.exports = {"taskType":"Plannable_taskType__16GBt","description":"Plannable_description__W8asC"};